module.exports = __webpack_public_path__ + "/images/ico-vendedores-puzzle.49fae1b.svg";